import React from 'react';

import { ProductRecommendationSource } from 'src/utils/analytics/trackers/internal-gtm-tracker/internal-gtm-tracker.types';
import { ProductCarousel as ProductCarouselV2 } from 'src/components/carousel-v2/types/product-carousel';
import { useSponsoredProductHandlers } from 'src/utils/ads/hooks/sponsored-products';
import { useRelatedItemsCarousel } from './use-related-items-carousel';

// Both fields are consumed indirectly via useRelatedItemsCarousel(props), not destructured directly.
/* eslint-disable react/no-unused-prop-types */
export type RelatedItemsCarouselProps = {
  productId: string;
  category: string;
};
/* eslint-enable react/no-unused-prop-types */

export function RelatedItemsCarousel(props: RelatedItemsCarouselProps): JSX.Element | null {
  const carouselProps = useRelatedItemsCarousel(props);
  const { products, loading, placement } = carouselProps;
  const label = `Related Items`;

  const { handleSponsoredProductClick, handleSponsoredProductImpression } = useSponsoredProductHandlers({
    trackerSource: ProductRecommendationSource.sponsored,
    adPlacement: 'pdp.carousel',
  });

  if (!loading && !products.length) {
    return null;
  }

  return (
    <ProductCarouselV2
      products={products}
      isLoading={loading}
      title={label}
      onProductClick={handleSponsoredProductClick}
      onQuickAddToCart={handleSponsoredProductClick}
      onProductView={handleSponsoredProductImpression}
      placement={placement}
    />
  );
}
